import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { omit, isEmpty } from 'lodash-es';
import { venomHistory } from 'client/utils/history/venom-history';
import { mergeFiltersIntoQuery } from 'site-modules/shared/utils/lease-deals/filter-url-utils';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { FILTER_QUERY_PARAMS } from 'site-modules/shared/constants/lease-deals/lease-deals';

export const useUrlFilterSync = setModelValue => {
  const query = useSelector(state => state.pageContext.location.query);
  const pathname = useSelector(state => state.pageContext.location.pathname);
  const routeFilters = useSelector(state => state.leaseDeals?.routeFilters);

  const queryRef = useRef(query);

  useEffect(() => {
    queryRef.current = query;
  }, [query]);

  const onUpdate = useCallback(
    async (filters, clearAll) => {
      const filtersWithoutId = clearAll ? filters : { ...filters, [FILTER_QUERY_PARAMS.ID]: [] };

      await setModelValue(LeaseDealsPaths.getSelectedFiltersPath(), LeaseDealsModel, filtersWithoutId);

      if (
        !!clearAll ||
        !isEmpty(
          omit(filtersWithoutId, [FILTER_QUERY_PARAMS.ID, FILTER_QUERY_PARAMS.PAGE_NUM, FILTER_QUERY_PARAMS.SORT_BY])
        )
      ) {
        setModelValue(LeaseDealsPaths.getFiltersPath(), LeaseDealsModel, null);
      }

      requestAnimationFrame(() => {
        setTimeout(() => {
          const url = `${pathname}?${mergeFiltersIntoQuery({ query: queryRef.current, filters: filtersWithoutId, clearAll, routeFilters })}`;
          venomHistory.push(url);
        });
      });
    },
    [setModelValue, pathname, routeFilters]
  );

  return onUpdate;
};
